<template>
  <div>
    <el-radio-group v-model="type">
      <el-radio-button :label="0">全部</el-radio-button>
      <el-radio-button :label="1">私教</el-radio-button>
      <el-radio-button :label="2">团课</el-radio-button>
    </el-radio-group>
    <el-table :data="selectData" style="width: 100%;margin-top: 10px;" :show-header="false">
      <el-table-column prop="startTime" label="时间" width="40">
      </el-table-column>
      <el-table-column prop="courseName" label="内容">
      </el-table-column>
      <el-table-column prop="trainerName" label="教练" width="50">
      </el-table-column>
      <el-table-column prop="reserve" label="人数" width="60" :formatter="function(row){return row.reserve+'/'+row.personMax}">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import services from '@/services'

export default {
  data () {
    return {
      type: 0,
      courses: []
    }
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      let that = this
      services.api.course.today({type: this.type}).then(function (response) {
        if (response.data.success) {
          that.courses = response.data.result
        }
      })
    },
    dateFormatter (row, column, cellValue) {
      let cdate = new Date(cellValue)
      let hours = cdate.getHours()
      if (hours < 10) { hours = '0' + hours }
      let minutes = cdate.getMinutes()
      if (minutes < 10) { minutes = '0' + minutes }
      return hours + ':' + minutes
    }
  },
  computed: {
    selectData () {
      return this.courses.filter(c => this.type === 0 || c.type === this.type)
    }
  }
}
</script>
<style scoped>
.el-radio-button>>>.el-radio-button__inner {
  font-size: 12px;
}

.el-table {
  font-size: inherit;
}
.el-table>>> .cell{
  padding-left: 5px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// TodayCourse.vue?166a47cf